import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { UrlConnectionEnum } from "../../enums/connection/url-connection.enum";
import { HttpService } from "../http-service/http.service";

@Injectable()
export class BannerService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets all posts
     * @author Starley Cazorla
     * @param segmentacao
     * @returns
     */
    async getAllBanners(segmentacao: any) {
        const config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.GET_ALL_BANNERS, segmentacao, config));
    }


}
